const generalUiTexts = {
	titlePart1: {
		da: 'Vikar'
	},
	titlePart2: {
		da: 'køreprøven'
	},
	subtitle: {
		da: 'Overlev en dag som vikar'
	},
	reset: {
		da: 'Nulstil',
		en: 'Reset'
	},
	start: {
		da: 'Start',
		en: 'Start',
	},
	viewResult: {
		da: 'Se resultat',
		en: 'View result'
	},
	playAgain: {
		da: 'Start nyt spil',
		en: 'Start new game'
	},
	loading: {
		da: 'Loader',
		en: 'Loading',
	}
};


module.exports = {
	generalUiTexts
};